import React from 'react'
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { getItemSelecter } from '../redux/slice/cartSlice';

const Header = () => {

    const countItem = useSelector(getItemSelecter)

    return (
        <div className='header'>
            <div className="m-4">
                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                    <div className="container-fluid">
                        <NavLink to='/' className="navbar-brand">
                            <img src="../Image/Flipkart.png" height="28" alt="..." />

                        </NavLink>
                        <button type="button" className="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarCollapse">
                            <div className="navbar-nav">
                                <NavLink to='/' className="nav-item nav-link active">Home</NavLink>

                            </div>
                            <div className="navbar-nav ms-auto">
                                <NavLink to='/login'
                                    className="nav-item nav-link active">Login</NavLink>
                                <NavLink to='/cart' exact activeClassName="active_class">
                                    <button type="button" class="btn btn-primary position-relative">
                                        <i class="fa fa-cart-plus" aria-hidden="true"></i>
                                        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                            {countItem.length}
                                            <span class="visually-hidden">unread messages</span>
                                        </span>
                                    </button>
                                </NavLink>
                            </div>

                        </div>
                    </div>
                </nav>
            </div>
        </div>
    )
}

export default Header;